import { useCallback } from 'react';
import { type NavigateOptions, useLocation } from 'react-router-dom';

import { useModals, type ModalPath } from '../router';

function useNavigateModals(modalPath: ModalPath) {
  const modals = useModals();
  const location = useLocation();

  const open = useCallback(
    (state: NavigateOptions['state'] = {}) => {
      // use any type due to type conflict with Generouted Path type since location.pathname is the current path
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const path = `${location.pathname}${location.search}` as any;
      modals.open(modalPath, { at: path, preventScrollReset: true, state });
    },
    [modals],
  );

  const close = useCallback(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const path = `${location.pathname}${location.search}` as any;
    modals.close({ at: path, preventScrollReset: true, state: {} });
  }, [modals]);

  return { open, close, current: modals.current };
}

export { useNavigateModals };
